const NoticeBoardText = "notice-of-board-meeting";
const NoticeBoardMeeting = "Notice";

export { NoticeBoardText, NoticeBoardMeeting };
